module.exports = __webpack_public_path__ + "img/ksc-1.d76968ba.png";